import { render } from "./RemovePassengerModalView.vue?vue&type=template&id=141630c5&scoped=true"
import script from "./RemovePassengerModalView.vue?vue&type=script&lang=js"
export * from "./RemovePassengerModalView.vue?vue&type=script&lang=js"

import "./RemovePassengerModalView.vue?vue&type=style&index=0&id=141630c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141630c5"]])

export default __exports__